const state = {
    ean: {
        items: [],
        supplier: {}
    },
    eans: {
        data: []
    },
}
const actions = {
    showEans: (context) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/eans`).then(response => {
                context.commit('SHOW_EANS', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    showEan: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/eans/${id}`).then(response => {
                context.commit('SHOW_EAN', response.data.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    storeEan: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(`/api/eans`, payload).then(response => {
                context.commit('STORE_EAN', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    updateEan: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.put(`/api/eans/${payload.id}`, payload).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    destroyEan: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/eans/${id}`).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },

}
const mutations = {

    SHOW_EAN: (state, payload) => {
        state.ean = payload
    },
    SHOW_EANS: (state, payload) => {
        state.eans = payload
    },
    STORE_EAN: (state, payload) => {
        state.ean = payload
    }
}
const getters = {
    ean: state => {
        return state.ean
    },
    eans: state => {
        return state.eans
    }
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}